import React, { useEffect, useState } from 'react';
import LinkService from '../system/LinkService';
import useApiCall from '../system/useApiCall';
import StandardTable from '../common/Component/StandardTable';
import { GridColumns, GridRowsProp } from '@mui/x-data-grid';
import AvatarDropCategoryTO from './AvatarDropCategoryTO';
import AvatarDropCategoryDialog from './AvatarDropCategoryDialog';

export default function AvatarDropCategoryPage() {
  const [editRow, setEditRow] = useState<number | null>(null);
  const [openDataDialog, setOpenDataDialog] = useState<boolean>(false);
  const [saveCount, setSaveCount] = useState<number>(0);
  const [dropCategoryList, setDropCategoryList] = useState<AvatarDropCategoryTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const apiCall = useApiCall();

  useEffect(() => {
    getAvatarDropCategoryAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveCount]);

  useEffect(() => {
    if (editRow === null && openDataDialog) {
      setOpenDataDialog(false);
    } else if (editRow !== null && !openDataDialog) {
      setOpenDataDialog(true);
    }
  }, [editRow, openDataDialog]);

  const getAvatarDropCategoryAll = () => {
    setIsLoading(true);
    apiCall.get(LinkService.getAllAvatarDropCategory()).then((data) => {
      if (data) {
        const list: AvatarDropCategoryTO[] = data;
        setDropCategoryList(list);
        setIsLoading(false);
      }
    });
  };

  const deleteAvatarDropCategoryData = (id: number) => {
    apiCall.delete(LinkService.deleteAvatarDropCategory(id), 'Datensatz gelöscht.').then((data) => {
      getAvatarDropCategoryAll();
    });
  };

  const getEditData = () => {
    const greetingData = dropCategoryList.find((item: AvatarDropCategoryTO) => item.id === editRow);
    return greetingData;
  };

  const columns: GridColumns = [
    { field: 'id', headerName: 'ID', type: 'number', width: 40, editable: false },
    { field: 'categoryName', headerName: 'Drop-Kategorie', flex: 9, editable: true },
  ];

  const rows: GridRowsProp = [...dropCategoryList];

  return (
    <div>
      <AvatarDropCategoryDialog
        openDialog={openDataDialog}
        setEditRow={setEditRow}
        editData={editRow ? getEditData() : undefined}
        saveCount={saveCount}
        setSaveCount={setSaveCount}
      />
      <StandardTable
        saveURL={LinkService.greetingPost()}
        editRowNumber={setEditRow}
        columns={columns}
        rows={rows}
        deleteFunction={deleteAvatarDropCategoryData}
        isLoading={isLoading}
      />
    </div>
  );
}
